import styled from '@emotion/styled';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { navigationService } from 'src/config/rootService';
import { SOURCE_TYPES } from 'src/modules/user/models/user';
import focusAreaImg from 'src/public/img/focus-areas.svg';
import getConnectedImg from 'src/public/img/get-connected.svg';
import howAreyouFeelingImg from 'src/public/img/how-youre-feeling.svg';
import marginaliaDeliveryImg from 'src/public/img/marginalia-delivery.svg';
import logoImg from 'src/public/img/mh-logo-text.svg';
import { CrisisModal } from 'src/shared/components/CrisisModal';
import { Button } from 'src/shared/ds/components/Button';
import { color } from 'src/shared/styles/variables';

const Container = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    flexDirection: 'column',
    textAlign: 'center',
});

const CrisisTitle = styled.p({
    fontWeight: 800,
    fontFamily: 'Avenir',
    fontSize: '16px',
    lineHeight: '24px',
    color: color.bismark,
    marginTop: '36px',
    marginBottom: '52px',
    cursor: 'pointer',
    textDecorationLine: 'underline',
});

const ButtonsContainer = styled.div({
    width: '240px',
    justifyContent: 'center',
    display: 'flex',
});

const PageTitle = styled.h1({
    fontWeight: 800,
    fontFamily: 'Avenir',
    fontSize: '28px',
    lineHeight: '32px',
    color: color.ebonyClay,
});

const PageSubtitle = styled.h1({
    fontWeight: 800,
    fontFamily: 'Avenir',
    fontSize: '16px',
    lineHeight: '24px',
    color: color.ebonyClay,
    marginBottom: '16px',
});

const PageDescription = styled.p({
    fontWeight: 400,
    fontFamily: 'Avenir',
    fontSize: '16px',
    lineHeight: '24px',
    color: color.blueBayoux,
    marginBottom: '24px',
    marginTop: '12px',
});

const BrandImage = styled.img({
    marginLeft: 32,
    marginTop: 20,
    width: '16em',
    cursor: 'pointer',
    marginRight: 12,
});

const IconList = styled.div({
    textAlign: 'left',
    width: 'fit-content',
    margin: 'auto',
});

const IconItem = styled.p({
    lineHeight: '20px',
    marginBottom: '12px',
});

const IconItemImage = styled.img({
    marginRight: '8px',
});

const IconItemText = styled.span({
    fontSize: '16px',
});

const goToTopicSelectionScreen = () => {
    navigationService.navigate('onboarding-categories');
};

const PageImage = styled.img({
    width: '180px',
});

export const StartAssessmentPage: React.FC = () => {
    const [showCrisisModal, setShowCrisisModal] = useState(false);
    const { t } = useTranslation();

    return (
        <>
            <BrandImage
                src={logoImg}
                onClick={() => {
                    window.location.href = 'https://www.modernhealth.com';
                }}
            />
            <Container>
                <div>
                    <PageImage src={marginaliaDeliveryImg} />
                    <PageTitle>{t('auth:start_assessment_page.title')}</PageTitle>

                    <PageDescription>{t('auth:start_assessment_page.description')}</PageDescription>

                    <PageSubtitle>{t('auth:start_assessment_page.subtitle')}</PageSubtitle>

                    <IconList>
                        <IconItem>
                            <IconItemImage src={focusAreaImg} />
                            <IconItemText>
                                {t('auth:start_assessment_page.icon_list.focus')}
                            </IconItemText>
                        </IconItem>
                        <IconItem>
                            <IconItemImage src={howAreyouFeelingImg} />
                            <IconItemText>
                                {t('auth:start_assessment_page.icon_list.feeling')}
                            </IconItemText>
                        </IconItem>
                        <IconItem>
                            <IconItemImage src={getConnectedImg} />
                            <IconItemText>
                                {t('auth:start_assessment_page.icon_list.connected')}
                            </IconItemText>
                        </IconItem>
                    </IconList>
                </div>

                <CrisisTitle onClick={() => setShowCrisisModal(true)}>
                    {t('onboarding:your_on_your_way_screen.crisis.title')}
                </CrisisTitle>

                <ButtonsContainer>
                    <Button
                        onClick={goToTopicSelectionScreen}
                        variant="primary"
                        title={t('auth:start_assessment_page.button.begin')}
                        size="large"
                        fullWidth
                    />
                </ButtonsContainer>

                <CrisisModal
                    visible={showCrisisModal}
                    onClose={() => {
                        setShowCrisisModal(false);
                    }}
                    source={SOURCE_TYPES.PRE_ONBOARDING}
                />
            </Container>
        </>
    );
};
